var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgJackpotIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.399 2H5.515l1.06 4.237L9.398 2zM7.267 7h5.465L10 2.901 7.267 7zm6.158-.763L14.485 2H10.6l2.824 4.237zM1.363 7l3.253-4.473L5.734 7h-4.37zm.065 1h4.556l1.876 7.504L1.428 8zm5.587 0l2.3 9.202L10 18l.684-.798L12.984 8H7.015zm11.556 0l-6.432 7.504L14.015 8h4.556zm.065-1h-4.371l1.118-4.473L18.636 7z",
    fill: "#9A9CAC"
  })));
}

export default SvgJackpotIcon;